var _circle, _rect, _line, _line2, _line3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnAddpcWBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-addpc-w-bg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1509",
    "data-name": "Ellipse 1509",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#3fa9f5",
    opacity: 0.099
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17083",
    "data-name": "Rectangle 17083",
    width: 31,
    height: 20,
    rx: 1,
    transform: "translate(19 19)",
    fill: "none",
    stroke: "#37a8e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    x2: 18,
    transform: "translate(25 47)",
    fill: "none",
    stroke: "#37a8e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    y2: 8,
    transform: "translate(29 39)",
    fill: "none",
    stroke: "#37a8e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_1036",
    "data-name": "Line 1036",
    y2: 8,
    transform: "translate(39 39)",
    fill: "none",
    stroke: "#37a8e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17976",
    "data-name": "Group 17976",
    transform: "translate(36 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25547",
    "data-name": "Path 25547",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1753",
    "data-name": "Ellipse 1753",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(3 3)",
    fill: "#eaf7ff",
    stroke: "#00aae5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1189",
    "data-name": "Line 1189",
    x2: 6,
    transform: "translate(9 12)",
    fill: "none",
    stroke: "#00aae5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1190",
    "data-name": "Line 1190",
    y2: 6,
    transform: "translate(12 9)",
    fill: "none",
    stroke: "#00aae5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAddpcWBg);
export default __webpack_public_path__ + "static/media/icn-addpc-w-bg.083c01887e79291365003d028bc3a5b3.svg";
export { ForwardRef as ReactComponent };